import { CustomerListPlugin } from './kpis/plugins/customer-list/customer-list.plugin';
import { KpiListPlugin } from './kpis/plugins/kpi-list/kpi-list.plugin';
import { CategoryPlugin } from './observations/plugins/category/category.plugin';
import { SelectCustomerModal } from './kpis/modals/select-customer/select-customer.modal';
import { AddWorkLogPlugin } from './work-logs/plugins/add-work-log/add-work-log.plugin';
import { CommentsPlugin } from './observations/plugins/comments/comments.plugin';
import { UrgentObservationsComponent } from './dashboards/widgets/urgent-observations/components/urgent-observations.component';
import { WorkedHoursComponent } from './dashboards/widgets/worked-hours/worked-hours.component';
import { IncidentPreventionsComponent } from './dashboards/widgets/incident-preventions/incident-preventions.component';
import { MostReturningObservationCategoriesComponent } from './dashboards/widgets/most-returning-observation-categories/most-returning-observation-categories.component';
import { AddObservationHeaderButtonPlugin } from './observations/plugins/add-observation-header-button/add-observation-header-button.plugin';
import { EditLocationModal } from './locations/modals/edit-location/edit-location.modal';
import { CreateLocationModal } from './locations/modals/create-location/create-location.modal';
import { LocationListPlugin } from './locations/plugins/location-list/location-list.plugin';

export const Plugins = [
    CustomerListPlugin,
    SelectCustomerModal,
    KpiListPlugin,
    CategoryPlugin,
    AddWorkLogPlugin,
    AddObservationHeaderButtonPlugin,
    CommentsPlugin,
    UrgentObservationsComponent,
    WorkedHoursComponent,
    IncidentPreventionsComponent,
    MostReturningObservationCategoriesComponent,
    EditLocationModal,
    CreateLocationModal,
    LocationListPlugin,
];



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/plugins.ts